import { NavLink } from 'react-router-dom';
import BtnDarkMode from "../btnDarkMode/BtnDarkMode"
import './style.css';
import { Bars3Icon } from '@heroicons/react/20/solid';

const Navbar = ({openNav}) => {
  const activeLink = 'nav-list__link nav-list__link--active';
  const normalLink = 'nav-list__link';

  return (
    <nav className="nav">
      <div className="container">
        <div className="nav-row">
          <NavLink to="/" className="logo">
          Pixel<strong>Craft</strong>
           
          </NavLink>

          <BtnDarkMode />

          <ul className="nav-list">
            <li className="nav-list__item">
              <NavLink
                to="/"
                className={({ isActive }) =>
                  isActive ? activeLink : normalLink
                }
              >
                Home
              </NavLink>
            </li>
            <li className="nav-list__item">
              <NavLink
                to="/projects"
                className={({ isActive }) =>
                  isActive ? activeLink : normalLink
                }
              >
                Projects
              </NavLink>
            </li>
            <li className="nav-list__item">
              <NavLink
                to="/gallery"
                className={({ isActive }) =>
                  isActive ? activeLink : normalLink
                }
              >
                Gallery
              </NavLink>
            </li>
            <li className="nav-list__item">
              <NavLink
                to="/contacts"
                className={({ isActive }) =>
                  isActive ? activeLink : normalLink
                }
              >
                Contacts
              </NavLink>
            </li>
          </ul>
          <button onClick={openNav} className='nav__icon'>
              <Bars3Icon />
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
